import { ja, enUS, es, pt } from "date-fns/locale";
import { timeAgo as timeAgoOrigin } from "@scrile/tools/dist/lib/TimeHelpers";
import { getLocale } from "@/lib/localeHelper";

export * from "@scrile/tools/dist/lib/TimeHelpers";

const PST_GMS_DIFF = -8;

export function dateToPST(date: Date): Date {
  const d = new Date(date.getTime());
  d.setMinutes(d.getMinutes() + d.getTimezoneOffset() + PST_GMS_DIFF * 60);
  return d;
}

export function formatDate(date: Date, options?: Partial<Intl.DateTimeFormatOptions>): string {
  return date.toLocaleString(getLocale(), options);
}

export function timeAgo(
  time: string | number | Date,
  { addSuffix, locale }: { addSuffix: boolean; locale?: string } = { addSuffix: false }
): string {
  let localeOptions;
  const localeName = locale || getLocale();

  if (localeName === "en-US") localeOptions = enUS;
  if (localeName === "ja") localeOptions = ja;
  if (localeName === "es") localeOptions = es;
  if (localeName === "pt") localeOptions = pt;

  return timeAgoOrigin(time, { addSuffix, locale: localeOptions });
}

export const getNow = () => new Date();
